import { render, staticRenderFns } from "./Split.vue?vue&type=template&id=562f9536&scoped=true&"
import script from "./Split.vue?vue&type=script&lang=js&"
export * from "./Split.vue?vue&type=script&lang=js&"
import style0 from "./Split.vue?vue&type=style&index=0&id=562f9536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562f9536",
  null
  
)

export default component.exports